import React from 'react';

const EmptyState = () => {
  return (
    <div className="empty-state">
      <div className="empty-icon">📚</div>
      <h3 className="empty-title">No problems yet!</h3>
      <p className="empty-text">Click &quot;Add Problem&quot; to start your DSA journey! 🚀</p>
    </div>
  );
};

export default EmptyState;